import { Component, ViewChild, Input } from '@angular/core';
import * as debug from 'debug';
import * as _ from 'lodash';
import { UserProvider } from '../../providers/user/user';
import { ToolsProvider } from '../../providers/tools/tools';
import { CrudApiProvider } from '../../providers/crud-api/crud-api';
import { ConfigProvider } from '../../providers/config/config';

@Component({
  selector: 'view-all-tags',
  templateUrl: 'view-all-tags.html',
})
export class ViewAllTagsComponent {
  log = debug('app:ViewAllTagsComponent');

  tags = [];
  @Input() location;
  openTagsModal = false;
  subs = [];

  constructor(
    public tools: ToolsProvider,
    public user: UserProvider,
    public crudApi: CrudApiProvider,
    public configs: ConfigProvider
  ) {
    this.tags = this.configs.get('hashtags');
    this.subs.push(
      this.configs.on('hashtagsUpdated', (hashtags) => {
        this.tags = hashtags;
        this.log('hashtags | toggle', this.tags);
      })
    );
  }

  ngOnDestroy() {
    _.each(this.subs, (s) => {
      if (s instanceof Function) {
        s();
      } else if (s.unsubscribe) {
        s.unsubscribe();
      }
    });
  }

  toggleTag(tag) {
    this.tools.emit('toggleTag', tag);
  }

  selectTags() {
    this.openTagsModal = false;
  }

  closeSlideOver(clickLocation) {
    if (clickLocation === 'tagSlideOver') {
      this.tools.emit('closeTagSlideOver');
    } else if (clickLocation === 'hashtagSlider') {
      this.tools.emit('closeHashtagSlider');
    }
  }

  // private dispatch() {
  //   const event = new CustomEvent('filteredTags', {
  //     detail: this.selectedTags || ['test'],
  //   });
  //   document.dispatchEvent(event);
  // }
}



// WEBPACK FOOTER //
// ./src/components/view-all-tags/view-all-tags.ts